import Vue from "vue";
import store from "./src/store/store";
import axios from "axios";
import config from "../config";
import _ from "lodash";
import * as moment from "moment";
import { Loading } from "element-ui";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.api_server_domain;

Vue.prototype._ = _;
Vue.prototype.moment = moment;

global.Vue = Vue;
global.store = store;
global.axios = axios;
global.config = config;
global._ = _;
global.moment = moment;

let loadingCount = 0;
let loading;

function showLoading() {
  if (loadingCount === 0) {
    loading = Loading.service({
      lock: true,
      text: "Loading ...",
      background: "rgba(0, 0, 0, 0)",
    });
  }
  loadingCount += 1;
}

function hideLoading() {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    loading.close();
  }
}

axios.interceptors.request.use(
  async (config) => {
    showLoading();
    const isAuth = Vue.prototype.$cookies.isKey("auth");

    if (isAuth) {
      const token = Vue.prototype.$cookies.get("auth").token;
      config.headers.Authorization = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  async (res) => {
    hideLoading();
    return res;
  },
  (err) => {
    hideLoading();
    if (401 === err.response.status && loadingCount <= 0) {
      Vue.prototype.$notify.error({
        title: "Error",
        message: err.response.data.message,
        position: "bottom-right",
        offset: 20,
        duration: 0,
      });
      setTimeout(() => {
        store.dispatch("user/logout");
        if (
          window.location.origin.includes(
            `${config.dashboard_backstage_domain}`
          )
        ) {
          window.location = `${config.dashboard_backstage_domain}/login`;
        } else {
          window.location = `${config.dashboard_domain}/login`;
        }
      }, 5000);
    }
    return Promise.reject(err);
  }
);

global.getTemplate = (item, marcos = {}, id, variables) => {
  let SDK_TYPE, INS_CLASS, MAIN_SCRIPT, w, h;
  if (item._type === CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM) {
    SDK_TYPE = "outstream";
    INS_CLASS = "utsvideoad";
    MAIN_SCRIPT = `
(ucfvad_async = window.ucfvad_async||[]).push({});
function noAd() {
    if (frameElement.parentElement != null) {
        frameElement.style.display = 'none';
        var adFrame = document.createElement('iframe');
        adFrame.style.width = '300px'
        adFrame.style.height = '250px';
        adFrame.scrolling = 'no';
        adFrame.style.border = '0px';
        frameElement.parentElement.appendChild(adFrame);
        adFrame.contentDocument.write('<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"><\\/script> <!-- 300x250 --> <ins class="adsbygoogle" style="display:inline-block;width:300px;height:250px" data-ad-client="ca-pub-6723338626478045" data-ad-slot="2202235780"></ins> <script> (adsbygoogle = window.adsbygoogle || []).push({}); <\\/script>');
        adFrame.contentDocument.body.style.textAlign = 'center';
    }
}
`;
  } else if (item._type === CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST) {
    MAIN_SCRIPT = `${config.ad_server_domain}/${item.creative_id}`;
  } else {
    SDK_TYPE = "web";
    INS_CLASS = "uts_async";
    MAIN_SCRIPT = `(uts_async = window.uts_async||[]).push({});`;
  }

  switch (item._type) {
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.MARQUEE:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROTATINGFERRISWHELL:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROLLING_CASTLE:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.CARDS:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SPINNER:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SCROLLINGBOX:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.INSKIN:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD_WITH_OUTSTREAM:
      w = 0;
      h = 0;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SWITCH:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SWAP:
      w = 300;
      h = 250;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.CAROUSEL:
      w = 600;
      h = 300;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER_WITH_OUTSTREAM:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.COUNT_DOWN:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.DATA_DRIVEN:
      w = item.width;
      h = item.height;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING_FLIP:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY
      .PARALLAX_SCROLLING_WITH_OUTSTREAM:
      w = 320;
      h = 480;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN_WITH_OUTSTREAM:
      w = 970;
      h = 250;
      break;
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM:
    case CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST:
      w = 640;
      h = 360;
      break;
  }

  const DATA_MARCOS = [
    `data-height="${h}"`,
    `data-width="${w}"`,
    `data-creative_id="${item.creative_id}"`,
  ];
  if (marcos.CACHE_BUSTER)
    DATA_MARCOS.push(`data-cache_buster="${marcos.CACHE_BUSTER}"`);
  if (marcos.CLICK_URL_ENC)
    DATA_MARCOS.push(`data-click_tracking="${marcos.CLICK_URL_ENC}"`);
  if (marcos.IMPRESSION_URL_ENC)
    DATA_MARCOS.push(`data-impression_tracking="${marcos.IMPRESSION_URL_ENC}"`);
  if (id === 'Verizon Media') {
    DATA_MARCOS.push(`data-iframe-break="true"`);
  }
  if (variables && variables.closeBtnType && variables.closeBtnType.id === 'Close Button Version 1') {
    DATA_MARCOS.push(`data-variables="closeBtn1"`);
  }

  let scriptTag = `<script type="text/javascript" src="${
    config.ad_server_domain
  }/sdk/${SDK_TYPE}"></script>`;
  let insTag = `<ins class="${INS_CLASS}" style="display:none;width:${w}px;height:${h}px"${DATA_MARCOS.join(
    "\n"
  )}></ins>`;
  let result;
  if (item._type === CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST) {
    const DATA_MARCOS = [];
    if (marcos.CACHE_BUSTER)
      DATA_MARCOS.push(`cache_buster=${marcos.CACHE_BUSTER}`);
    result = `${MAIN_SCRIPT}?${DATA_MARCOS.join("&")}`;
  } else {
    result = `${scriptTag}\n${insTag}\n<script>${MAIN_SCRIPT}</script>`;
  }

  return result;
};
